import React from 'react'

import { InputField } from '../../../../formComponents'

import { fieldStyles } from '../../styles'

export default (props) => <InputField {...fieldStyles} {...props} />
